import { reactive } from "vue";

export const loadingState = reactive({
  active: false,
  text: "Cargando...",
  counter: 0,
});

function show(opts = {}) {
  loadingState.counter += 1;
  loadingState.active = true;
  if (opts.text) loadingState.text = opts.text;
}

function hide() {
  loadingState.counter = Math.max(0, loadingState.counter - 1);
  if (loadingState.counter === 0) loadingState.active = false;
}

function reset() {
  loadingState.counter = 0;
  loadingState.active = false;
}

export default {
  install(app) {
    app.config.globalProperties.$loading = { show, hide, reset, state: loadingState };
  },
};
